//#region src/js/filter-remove.js
var OptionRemove = class extends HTMLElement {
	connectedCallback() {
		if (this.initialized) return;
		this.initialized = true;
		this.querySelector("a").addEventListener("click", (event) => {
			event.preventDefault();
			(this.closest("product-filter-form") || document.querySelector("product-filter-form")).onActiveFilterClick(event);
		});
	}
};
if (!customElements.get("filter-remove")) customElements.define("filter-remove", OptionRemove);
//#endregion
